import { isUndNullEmp } from '../../helpers/main.js';

export class SystemAccess {
    constructor(
        _id = 0,
        _companyId = 0,
        _customerId = 0,
        _userId = '',
        _analystId = '',
        _registerDate = '',
        _userRegisterDate = '',
        _informCreationUserId = '',
        _informCreation = false,
        _informCreationDate = '',
        _informCompletion = false,
        _informCompletionDate = '',
        _statusId = 0,
        _typeId = 0,
        _commentary = '',
        _purchase = false,
        _billToPay = false,
        _requirements = false,
        _requests = false,
        _paymentInformation = false,
        _systemAccesses = false,
        _services = false,
        _backupReviews = false,
        _dataCenter = false,
        _parameters = false,
        _domainHosting = false,
        _remoteConnectionsDNS = false,
        _register = '',
    ) {
        this.id = _id;
        this.companyId = _companyId;
        this.customerId = _customerId;
        this.userId = _userId;
        this.analystId = _analystId;
        this.registerDate = _registerDate;
        this.userRegisterDate = _userRegisterDate;
        this.informCreationUserId = _informCreationUserId;
        this.informCreation = _informCreation;
        this.informCreationDate = _informCreationDate;
        this.informCompletion = _informCompletion;
        this.informCompletionDate = _informCompletionDate;
        this.statusId = _statusId;
        this.typeId = _typeId;
        this.commentary = _commentary;
        this.purchase = _purchase;
        this.billToPay = _billToPay;
        this.requirements = _requirements;
        this.requests = _requests;
        this.paymentInformation = _paymentInformation;
        this.systemAccesses = _systemAccesses;
        this.services = _services;
        this.backupReviews = _backupReviews;
        this.dataCenter = _dataCenter;
        this.parameters = _parameters;
        this.domainHosting = _domainHosting;
        this.remoteConnectionsDNS = _remoteConnectionsDNS;
        this.register = _register;
    }

    static getClassName = () => {
        return 'SystemAccess - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    CompanyId: 0,
                    CustomerId: 0,
                    UserId: 10,
                    AnalystId: 10,
                    RegisterDate: 10,
                    UserRegisterDate: 10,
                    InformCreationUserId: 10,
                    InformCreation: 1,
                    InformCreationDate: 10,
                    InformCompletion: 1,
                    InformCompletionDate: 10,
                    StatusId: 0,
                    TypeId: 0,
                    Commentary: 1,
                    Purchase: 1,
                    BillToPay: 1,
                    Requirements: 1,
                    Requests: 1,
                    PaymentInformation: 1,
                    SystemAccesses: 1,
                    Services: 1,
                    BackupReviews: 1,
                    DataCenter: 1,
                    Parameters: 1,
                    DomainHosting: 1,
                    RemoteConnectionsDNS: 1,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    CompanyId: 450,
                    customerId: 450,
                    UserId: 450,
                    AnalystId: 450,
                    RegisterDate: 30,
                    UserRegisterDate: 30,
                    InformCreationUserId: 450,
                    InformCreation: 1,
                    InformCreationDate: 30,
                    InformCompletion: 1,
                    InformCompletionDate: 30,
                    StatusId: 450,
                    TypeId: 450,
                    Commentary: 1000,
                    Purchase: 1,
                    BillToPay: 1,
                    Requirements: 1,
                    Requests: 1,
                    PaymentInformation: 1,
                    SystemAccesses: 1,
                    Services: 1,
                    BackupReviews: 1,
                    DataCenter: 1,
                    Parameters: 1,
                    DomainHosting: 1,
                    RemoteConnectionsDNS: 1,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    companyId: 0,
                    customerId: 0,
                    userId: 10,
                    analystId: 10,
                    registerDate: 10,
                    userRegisterDate: 10,
                    informCreationUserId: 10,
                    informCreation: 1,
                    informCreationDate: 10,
                    informCompletion: 1,
                    informCompletionDate: 10,
                    statusId: 0,
                    typeId: 0,
                    commentary: 1,
                    purchase: 1,
                    billToPay: 1,
                    requirements: 1,
                    requests: 1,
                    paymentInformation: 1,
                    systemAccesses: 1,
                    services: 1,
                    backupReviews: 1,
                    dataCenter: 1,
                    parameters: 1,
                    domainHosting: 1,
                    remoteConnectionsDNS: 1,
                    register: 10,
                },
                max: {
                    id: 450,
                    companyId: 450,
                    customerId: 450,
                    userId: 450,
                    analystId: 450,
                    registerDate: 30,
                    userRegisterDate: 30,
                    informCreationUserId: 450,
                    informCreation: 1,
                    informCreationDate: 30,
                    informCompletion: 1,
                    informCompletionDate: 30,
                    statusId: 450,
                    typeId: 450,
                    commentary: 1000,
                    purchase: 1,
                    billToPay: 1,
                    requirements: 1,
                    requests: 1,
                    paymentInformation: 1,
                    systemAccesses: 1,
                    services: 1,
                    backupReviews: 1,
                    dataCenter: 1,
                    parameters: 1,
                    domainHosting: 1,
                    remoteConnectionsDNS: 1,
                    register: 30,
                },
            };
        }
    }

    //#region old code
    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'SystemAccess / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/SystemAccess/', `${settings.backend.urls.imageUserIds}${settings.backend.urls.paymentInformations}/`);
    //             response.result = `${settings.backend.urls.api}${userId}`
    //         } else {
    //             response.result = `${settings.backend.urls.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }
    //#endregion old code

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: SystemAccess.getClassName() })?.result) {
            if (upperCase) {
                return new SystemAccess(
                    obj.Id,
                    obj.CompanyId,
                    obj.CustomerId,
                    obj.UserId,
                    obj.AnalystId,
                    obj.RegisterDate,
                    obj.UserRegisterDate,
                    obj.InformCreationUserId,
                    obj.InformCreation,
                    obj.InformCreationDate,
                    obj.InformCompletion,
                    obj.InformCompletionDate,
                    obj.StatusId,
                    obj.TypeId,
                    obj.Commentary,
                    obj.Purchase,
                    obj.BillToPay,
                    obj.Requirements,
                    obj.Requests,
                    obj.PaymentInformation,
                    obj.SystemAccesses,
                    obj.Services,
                    obj.BackupReviews,
                    obj.DataCenter,
                    obj.Parameters,
                    obj.DomainHosting,
                    obj.RemoteConnectionsDNS,
                    obj.Register,
                );
            } else {
                return new SystemAccess(
                    obj.id,
                    obj.companyId,
                    obj.customerId,
                    obj.userId,
                    obj.analystId,
                    obj.registerDate,
                    obj.userRegisterDate,
                    obj.informCreationUserId,
                    obj.informCreation,
                    obj.informCreationDate,
                    obj.informCompletion,
                    obj.informCompletionDate,
                    obj.statusId,
                    obj.typeId,
                    obj.commentary,
                    obj.purchase,
                    obj.billToPay,
                    obj.requirements,
                    obj.requests,
                    obj.paymentInformation,
                    obj.systemAccesses,
                    obj.services,
                    obj.backupReviews,
                    obj.dataCenter,
                    obj.parameters,
                    obj.domainHosting,
                    obj.remoteConnectionsDNS,
                    obj.register,
                );
            }
        } else {
            return new SystemAccess();
        }
    }
}